import { Dialog, DialogActions } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { styles } from "./styles";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class DialogComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialogs: this.props.flagOpen || false,
    };
    this.handleDialogOpen = this.handleDialogOpen.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  handleDialogClose() {
    this.setState({ openDialogs: false });
  }
  handleDialogOpen() {
    this.setState({ openDialogs: true });
  }
  render() {
    const { classes, paperWidth } = this.props;
    return (
      <Dialog
        open={this.state.openDialogs}
        TransitionComponent={Transition}
        keepMounted
        onClose={this.props.handleDialogClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        classes={{
          paperWidthSm: paperWidth ? paperWidth : classes.paperWidthSm,
        }}
      >
        {this.props.children}
        <DialogActions classes={{ root: classes.rootDialogActions }}>
          <IconButton
            aria-label="Close"
            size="small"
            className={classes.marginCloseButton}
            onClick={this.props.handleDialogClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  }
}

// Dialog.propTypes = {
//     classes: PropTypes.object.isRequired,
//     theme: PropTypes.object.isRequired,
// };
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: false })(DialogComponent)
  )
);
